var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.235 5C7.79706 5 5 7.79706 5 11.235C5 14.6729 7.79706 17.4699 11.235 17.4699C12.6377 17.4699 13.9299 16.9995 14.9712 16.216L17.4982 18.7422C17.6697 18.9138 17.8951 19 18.1202 19C18.3453 19 18.5707 18.9138 18.7422 18.7422C19.0862 18.3983 19.0862 17.8421 18.7422 17.4982L16.216 14.9712C16.9995 13.9299 17.4699 12.6377 17.4699 11.235C17.4699 7.79706 14.6729 5 11.235 5ZM6.75956 11.235C6.75956 8.76687 8.76687 6.75956 11.235 6.75956C13.7031 6.75956 15.7104 8.76687 15.7104 11.235C15.7104 13.7031 13.7031 15.7104 11.235 15.7104C8.76687 15.7104 6.75956 13.7031 6.75956 11.235Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8bbfc6091f399b313a1522b2b9d4d3fe.svg";
export { ForwardRef as ReactComponent };